/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `STARTUP` - Startup * `EMPRESA_JUNIOR` - Empresa júnior * `SETOR` - Setor
 */
export enum TipoC3aEnum {

    STARTUP = 'STARTUP',

    EMPRESA_JUNIOR = 'EMPRESA_JUNIOR',

    SETOR = 'SETOR'
}

